import React from 'react';
import DescribeMealContainer from './DescribeMealContainer';
import {
  TrackerExtractIngredientsConnectorApollo,
  withMobileAppMode,
} from '@front-activerse/common-components';
import { useLocation } from 'react-router-dom';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';

const DescribeMealPage: React.FC<{ mobileAppMode: boolean; fromUserMeals?: boolean }> = ({
  mobileAppMode,
  fromUserMeals,
}) => {
  const location = useLocation();

  const aiAccess = sessionStorage.getItem('aiAccess');

  if (aiAccess === 'true' || mobileAppMode) {
    return (
      <TrackerExtractIngredientsConnectorApollo>
        {({ extractIngredients, cancelExtractIngredients }) => (
          <DescribeMealContainer
            extractIngredients={extractIngredients}
            cancelExtractIngredients={cancelExtractIngredients}
            key={location.key} // Force re-render
            fromUserMeals={fromUserMeals}
          />
        )}
      </TrackerExtractIngredientsConnectorApollo>
    );
  }

  return <TrackerNoAccess />;
};

export default withMobileAppMode(DescribeMealPage);
